export default __webpack_public_path__ + "static/media/schedule_mobile.2c8c6ef4.jpg";